<script>
	export let toggleMenu;
	export let isMenuOpen;

	let hamburgerBaseClass =
		'bg-transparent border inline-flex items-center justify-center p-2 rounded-md focus:outline-none';
	let hamburgerClass =
		hamburgerBaseClass +
		' text-gray-900 border-gray-900 border-2 md:border-3 dark:text-gray-100 dark:border-gray-100';
</script>

<button class="{hamburgerClass} mt-4 md:mt-3" on:click={toggleMenu}>
	{#if isMenuOpen == false}
		<svg
			class="block h-3 w-3 md:h-5 md:w-5 scale-90 xs:scale-100"
			stroke="currentColor"
			fill="none"
			viewBox="0 0 24 24"
		>
			<path
				stroke-linecap="round"
				stroke-linejoin="round"
				stroke-width="4"
				d="M4 6h16M4 12h16M4 18h16"
			/>
		</svg>
	{:else}
		<svg class="block h-3 w-3 md:h-5 md:w-5" stroke="currentColor" fill="none" viewBox="0 0 24 24">
			<path
				stroke-linecap="round"
				stroke-linejoin="round"
				stroke-width="4"
				d="M6 18L18 6M6 6l12 12"
			/>
		</svg>
	{/if}
</button>
